// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Json from "../primitives/Json.res.js";
import * as Uuid from "../externals/Uuid.res.js";
import * as Uuid$1 from "uuid";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";

let CannotParseDatetime = /* @__PURE__ */Primitive_exceptions.create("Scalar.Datetime.CannotParseDatetime");

let CannotSerializeDatetime = /* @__PURE__ */Primitive_exceptions.create("Scalar.Datetime.CannotSerializeDatetime");

function parse(json) {
  let datetime = Stdlib_Option.map(Json.decodeString(json), v => new Date(v));
  if (datetime !== undefined) {
    if (Number.isNaN(datetime.getTime())) {
      throw {
        RE_EXN_ID: CannotParseDatetime,
        Error: new Error()
      };
    }
    return datetime;
  }
  throw {
    RE_EXN_ID: CannotParseDatetime,
    Error: new Error()
  };
}

let isDate = (date => date instanceof Date);

function serialize(date) {
  if (isDate(date)) {
    return Json.encodeString(date.toISOString());
  }
  throw {
    RE_EXN_ID: CannotSerializeDatetime,
    Error: new Error()
  };
}

let CannotParseText = /* @__PURE__ */Primitive_exceptions.create("Scalar.Text.CannotParseText");

let CannotSerializeText = /* @__PURE__ */Primitive_exceptions.create("Scalar.Text.CannotSerializeText");

function parse$1(json) {
  let string = Json.decodeString(json);
  if (string !== undefined) {
    return string;
  }
  throw {
    RE_EXN_ID: CannotParseText,
    Error: new Error()
  };
}

function serialize$1(text) {
  let match = typeof text;
  if (match === "string") {
    return Json.encodeString(text);
  }
  throw {
    RE_EXN_ID: CannotSerializeText,
    Error: new Error()
  };
}

let Text = {
  CannotParseText: CannotParseText,
  CannotSerializeText: CannotSerializeText,
  parse: parse$1,
  serialize: serialize$1
};

let CannotParseCku = /* @__PURE__ */Primitive_exceptions.create("Scalar.CKU.CannotParseCku");

let CannotSerializeCku = /* @__PURE__ */Primitive_exceptions.create("Scalar.CKU.CannotSerializeCku");

function parse$2(json) {
  let val;
  try {
    val = Stdlib_Option.map(Stdlib_Option.flatMap(Json.decodeString(json), Uuid.fromString), uuid => [
      Uuid$1.version(uuid),
      uuid
    ]);
  } catch (exn) {
    throw {
      RE_EXN_ID: CannotParseCku,
      Error: new Error()
    };
  }
  if (val !== undefined) {
    if (val[0] !== 4) {
      throw {
        RE_EXN_ID: CannotParseCku,
        Error: new Error()
      };
    }
    return val[1];
  }
  throw {
    RE_EXN_ID: CannotParseCku,
    Error: new Error()
  };
}

function serialize$2(cku) {
  let match = Stdlib_Option.map(Uuid.fromString(cku), v => Uuid$1.version(v));
  if (match !== undefined) {
    if (match !== 4) {
      throw {
        RE_EXN_ID: CannotSerializeCku,
        Error: new Error()
      };
    }
    return Json.encodeString(cku);
  }
  throw {
    RE_EXN_ID: CannotSerializeCku,
    Error: new Error()
  };
}

let CKU = {
  CannotParseCku: CannotParseCku,
  CannotSerializeCku: CannotSerializeCku,
  parse: parse$2,
  serialize: serialize$2
};

let Datetime = {
  CannotParseDatetime: CannotParseDatetime,
  CannotSerializeDatetime: CannotSerializeDatetime,
  parse: parse,
  serialize: serialize
};

export {
  Datetime,
  Text,
  CKU,
}
/* Uuid Not a pure module */
